import React from 'react';
import { ISubLinksHeaderProps } from '../../IFooter';
import { useTranslator } from '../../../header/locales-provider';

const SubLinksHeader = ({ navigationHeader }: ISubLinksHeaderProps): JSX.Element => {
  const locales = useTranslator('global');
  const title = navigationHeader?.toLowerCase();
  return (
    <div className="flex flex-row justify-between mb-base" data-testid="sub-header">
      <div className="flex-auto">
        <h3 aria-hidden={title === 'learn more'} className="text-white text-xl font-medium">{navigationHeader}</h3>
        {title === 'learn more' && <h3 className="text-white sr-only text-xl font-medium">{locales?.['aria.learnmore.title']}</h3>}
      </div>
    </div>
  );
};

export default SubLinksHeader;
